import axios from "axios";
import { BASE_URL } from "../../api/baseConfig";
import {
  PLATFORM_REF_CREATE_FAIL,
  PLATFORM_REF_CREATE_REQUEST,
  PLATFORM_REF_CREATE_SUCCESS,

  PLATFORM_REF_DELETE_FAIL,

  PLATFORM_REF_DELETE_REQUEST,

  PLATFORM_REF_DELETE_SUCCESS,

  PLATFORM_REF_EDIT_FAIL,
  PLATFORM_REF_EDIT_REQUEST,
  PLATFORM_REF_EDIT_SUCCESS,
  PLATFORM_REF_LIST_FAIL,
  PLATFORM_REF_LIST_SUCCESS,
  PLATFORM_REF_UPDATE_FAIL,
  PLATFORM_REF_UPDATE_REQUEST,
  PLATFORM_REF_UPDATE_SUCCESS,
} from "../Constants/PlatformRefConstants";
import { logout } from "./userActions";

export const listPlatformRefs = ({page}) => async (dispatch) => {
  try {
    const { data } = await axios.get(
      `${BASE_URL}/api/platformref/AZ/getall?page=${page}`
    );
    dispatch({ type: PLATFORM_REF_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: PLATFORM_REF_LIST_FAIL,
      payload: message,
    });
  }
};

export const platformRefCreate =
  ({ catalog, content_type, platform,row_number }) =>
  async (dispatch, getState) => {
    dispatch({ type: PLATFORM_REF_CREATE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Authorization": `${userInfo.token}`,
      },
    };
    try {
      const { data } = await axios.post(
        `${BASE_URL}/api/platformref/add`,
        { catalog:catalog.id, content_type:content_type.id, platform:platform.id,row_number },
        config
      );
      dispatch({ type: PLATFORM_REF_CREATE_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: PLATFORM_REF_CREATE_FAIL,
        payload: message,
      });
    }
  };

// EDIT PLATFORM_REF_y
export const editPlatformRef = (id) => async (dispatch) => {
  try {
    dispatch({ type: PLATFORM_REF_EDIT_REQUEST });
    const { data } = await axios.get(
      `${BASE_URL}/api/platformref/getbyid/${id}/AZ`
    );
    dispatch({ type: PLATFORM_REF_EDIT_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: PLATFORM_REF_EDIT_FAIL,
      payload: message,
    });
  }
};

// UPDATE PRODUCT
export const updatePlatformRefs =
  ({ id,catalog, content_type, platform,row_number,old_row_number }) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      dispatch({ type: PLATFORM_REF_UPDATE_REQUEST });
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/api/platformref/update/${id}`,
        { catalog:catalog.id, content_type:content_type.id, platform:platform.id,row_number,old_row_number },
        config
      );

      dispatch({ type: PLATFORM_REF_UPDATE_SUCCESS, payload: data });
      dispatch({ type: PLATFORM_REF_EDIT_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: PLATFORM_REF_UPDATE_FAIL,
        payload: message,
      });
    }
  };

  
  // DELETE PRODUCT
export const deletePlatformRef = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PLATFORM_REF_DELETE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Authorization": `${userInfo.token}`,
      },
    };

    await axios.delete(`${BASE_URL}/api/platformref/delete/${id}`, config);

    dispatch({ type: PLATFORM_REF_DELETE_SUCCESS });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: PLATFORM_REF_DELETE_FAIL,
      payload: message,
    });
  }
};